import React from 'react';
import { Grid, Icon } from 'semantic-ui-react';
import Tags from './Tags';
import HighlightDescription from './HighlightDescription';
import ProfileModal from '../../ProfileModal';

const TagAndHighlights = ({ expert, searchData }) => (
  <Grid>
    <Grid.Row columns={2}>
      <Grid.Column width={14} className="highlight-section">
        <Tags expert={expert} searchData={searchData} />
        <HighlightDescription searchData={searchData} />
      </Grid.Column>
      <Grid.Column width={2} textAlign="center" verticalAlign="middle">
        <ProfileModal expertId={expert.id}>
          <Icon name="angle right" size="large" color="black" link />
        </ProfileModal>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default TagAndHighlights;
